import { Boxes } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { InventoryPage } from './pages/InventoryPage'

/**
 * Inventory — M9 DataView with two view modes (Stock · Lots).
 *
 * Compact density default per spec §9.3 — warehouse staff facing, high
 * row counts. Replaces reports.siliconesplus.com/inventory.
 */
export default defineModule({
  id: 'inventory',
  name: 'Inventory',
  shortName: 'Inventory',
  icon: Boxes,
  navSection: 'warehouse',
  navOrder: 5,
  // Sprint 13a default-collapsed (D-5a): Finance views inventory
  // occasionally for valuation context but their daily focus is
  // margins / quotes / AR-AP. Default-collapse the Warehouse section
  // for finance users (carries over from Inventory's own former
  // section); admin/operations/viewer roles keep it expanded.
  navCollapsedForRoles: ['finance'],
  urlNamespace: '/inventory',
  routes: [{ path: '/', element: InventoryPage, label: 'Inventory' }],
  permissions: ['admin', 'operations', 'operations_logistics', 'purchasing', 'finance'],
  densityDefault: 'compact',
  filterRailDefault: 'collapsed',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g i',

  commandPaletteEntries: [
    {
      label: 'Go to Inventory',
      keywords: ['inventory', 'stock', 'warehouse', 'lot', 'expiry'],
      path: '/',
      group: 'modules',
      shortcut: 'g i',
    },
  ],

  deepLinkHandlers: [
    {
      entity: 'product',
      label: 'View inventory for this product',
      buildPath: (productId) => `/?product=${productId}`,
    },
  ],
})
